const read = (key, fallback = "") => {
  const value = import.meta.env?.[key];
  return typeof value === "string" && value.trim() ? value.trim() : fallback;
};

export const appConfig = Object.freeze({
  version: typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "0.0.0",
  versionCode: Number(typeof __APP_VERSION_CODE__ !== "undefined" ? __APP_VERSION_CODE__ : 0),
  apiBase: read("VITE_API_BASE_URL").replace(/\/$/, ""),
  modelBase: read("VITE_MODEL_BASE_URL", "/model").replace(/\/$/, ""),
  serverUrl: read("VITE_SERVER_URL").replace(/\/$/, ""),
  modelVariant: read("VITE_MODEL_VARIANT", "auto"),
  supabaseUrl: read("VITE_SUPABASE_URL"),
  supabaseAnonKey: read("VITE_SUPABASE_ANON_KEY"),
  ortWasmBase: read("VITE_ORT_BASE_URL", "/ort/").replace(/\/?$/, "/"),
  liveIntervalMs: Number(read("VITE_LIVE_INTERVAL_MS", "400")),
  clipSeconds: Number(read("VITE_CLIP_SECONDS", "8"))
});

export const hasApi = () => Boolean(appConfig.apiBase);
